export const APPLICATION_TYPES = {
    END_USER: "End User Application",
    SERVER_TO_SERVER: "Server to Server Application",
    EXTENSION: "Extension Application"
};


export const APPLICATION_TYPE_GRANT_TYPES = {
    AUTHORIZATION_CODE: "Authorization Code Grant",
    CLIENT_CREDENTIALS: "Client Credentials Grant"
};